import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames('flex', 'items-center', 'justify-center', 'p-2.5');

interface Props {
  children: ReactNode;
}

const MenuHeader = ({ children }: Props) => (
  <div className={className}>{children}</div>
);

export default MenuHeader;
